import type { RovoConfiguration } from '@jira/ai-rovo_actions-shared-types/src/RovoConfiguration.types.tsx';
import {
	createActionsHook,
	createSelectorHook,
} from '@atlassian/react-sweet-state/src/components/hook';
import { createStore } from '@atlassian/react-sweet-state/src/store/create';
import type { Action } from '@atlassian/react-sweet-state/src/types';

interface State {
	configuration: RovoConfiguration;
}

const noopConfiguration: RovoConfiguration = {
	getActions: async () => [],
};

const initialState: State = {
	configuration: noopConfiguration,
};

const actions = {
	setConfiguration:
		(configuration: RovoConfiguration): Action<State> =>
		({ setState }) => {
			setState({ configuration });
		},
	resetConfiguration:
		(): Action<State> =>
		({ setState }) => {
			setState({ configuration: noopConfiguration });
		},
};

export const aiRovoCurrentRouteConfigurationStore = createStore<State, typeof actions>({
	initialState,
	actions,
});

export const useAiRovoCurrentRouteConfigurationStoreActions = createActionsHook(
	aiRovoCurrentRouteConfigurationStore,
);
export const useAiRovoCurrentRouteConfigurationStore = createSelectorHook(
	aiRovoCurrentRouteConfigurationStore,
);
